// extracted by mini-css-extract-plugin
export default {"container":"container--qm5HW","box":"box--QTR6t","title":"title--IC0ib","subtitle":"subtitle--oJN2g","countdown":"countdown--q4BCC"};